import { PropsWithChildren } from 'react';
import classNames from 'classnames';
interface Props extends PropsWithChildren {
  className?: string;
  isSingleButton?: boolean;
}
export const AppButton = ({
  className,
  isSingleButton,
  children
}: Props) => {
  return <div className={classNames('grid min-h-[76px] w-full items-center gap-4 border-t border-border-gray-light bg-surface-solid-50 px-4 lg:hidden [&>*]:w-full', {
    'grid-cols-1 [&>*]:col-span-1': isSingleButton,
    'grid-cols-2 [&>*]:col-span-1': !isSingleButton
  }, className)} data-sentry-component="AppButton" data-sentry-source-file="app-button.tsx">
            {children}
        </div>;
};